import * as Yup from 'yup';

export const unitValidationSchema = Yup.object().shape({
  number: Yup.string().required('O número da unidade é obrigatório'),
  description: Yup.string().max(1000, 'Descrição deve ter no máximo 1000 caracteres'),
  sector_id: Yup.string().required('Setor é obrigatório'),
});